import {Component, computed, input, output, ChangeDetectionStrategy} from "@angular/core"
import {MatTooltipModule} from "@angular/material/tooltip"
import {PricingNode} from "@cm/pricing/pricing-node"
import {PriceContainer} from "@cm/pricing/nodes/price-container"
import {VariantConditionNode} from "@cm/pricing/nodes/variant-condition-node"
import {VariantConditionNodeComponent} from "@pricing/components/node-visualizers/variant-condition-node/variant-condition-node.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-price-container",
    templateUrl: "./price-container-node.component.html",
    styleUrls: ["./price-container-node.component.scss", "../node-styles.scss"],
    imports: [VariantConditionNodeComponent, MatTooltipModule],
})
export class PriceContainerNodeComponent {
    readonly $node = input.required<PricingNode>({alias: "node"})

    readonly $priceContainerNode = computed<PriceContainer | undefined>(() => {
        const node = this.$node()
        if (node instanceof PriceContainer) return node
        else return undefined
    })

    readonly $variantConditionNode = computed<VariantConditionNode | undefined>(() => {
        const condition = this.$priceContainerNode()?.parameters.condition
        return condition instanceof VariantConditionNode ? condition : undefined
    })

    readonly $description = computed<string>(() => {
        const node = this.$priceContainerNode()
        const destcription = node?.getDescription()
        if (destcription) return destcription
        return ""
    })

    readonly conditionRemoved = output<void>()
}
